import { Paper, CardContent, Typography, Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { formatCurrency } from '../../../utils/utils';

const DealCard = ({ deal }) => {
	const navigate = useNavigate();
	const { tenantId } = useParams();

	const handleCardClick = () => {
		navigate(`/tenants/${tenantId}/apps/investing/deals/${deal.id}`);
	};

	return (
		<Paper
			elevation={1}
			onClick={handleCardClick}
			sx={{
				backgroundColor: 'background.paper',
				borderRadius: 1,
				border: '1px solid',
				borderColor: 'divider',
				transition: 'all 0.2s',
				'&:hover': {
					transform: 'translateY(-2px)',
					boxShadow: 2,
					cursor: 'pointer',
				},
			}}
		>
			<CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
				{/* Project name */}
				<Typography
					variant='h6'
					sx={{
						mb: 1.5,
						color: 'primary.main',
						textDecoration: 'none',
						'&:hover': {
							textDecoration: 'underline',
						},
					}}
				>
					{deal.name}
				</Typography>

				{/* All other data with consistent labeling and spacing */}
				<Box
					sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 1.5 }}
				>
					{deal.owner_name && (
						<Typography variant='body2' color='text.secondary'>
							<span style={{ fontWeight: 500 }}>Owner:</span>{' '}
							{deal.owner_name || deal.owner_id}
						</Typography>
					)}

					{deal.company?.name && (
						<Typography variant='body2' color='text.secondary'>
							<span style={{ fontWeight: 500 }}>Company:</span>{' '}
							{deal.company.name}
						</Typography>
					)}

					{deal.fund?.name && (
						<Typography variant='body2' color='text.secondary'>
							<span style={{ fontWeight: 500 }}>Fund:</span> {deal.fund.name}
						</Typography>
					)}

					{deal.deal_size && (
						<Typography variant='body2' color='text.secondary'>
							<span style={{ fontWeight: 500 }}>Size:</span>{' '}
							{formatCurrency(deal.deal_size, deal.currency || 'USD')}
						</Typography>
					)}

					{deal.company?.industry && (
						<Typography variant='body2' color='text.secondary'>
							<span style={{ fontWeight: 500 }}>Industry:</span>{' '}
							{deal.company.industry}
						</Typography>
					)}
				</Box>
			</CardContent>
		</Paper>
	);
};

export default DealCard;
